import { render, staticRenderFns } from "./CallbackPage.vue?vue&type=template&id=a8e731e0&scoped=true"
import script from "./CallbackPage.vue?vue&type=script&lang=ts"
export * from "./CallbackPage.vue?vue&type=script&lang=ts"
import style0 from "./CallbackPage.vue?vue&type=style&index=0&id=a8e731e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e731e0",
  null
  
)

export default component.exports